/**
 * @name getComputedBackgroundColor
 *
 * @description Returns the computed background color from parent element
 *
 * @example
 * import { getComputedBackgroundColor } from '@workbench/core';
 *
 * getComputedBackgroundColor(this.el); // rgb(255, 255, 255)
 */
export function getComputedBackgroundColor(el: HTMLElement): string {
  const backgroundColor = getComputedStyle(el.parentElement).backgroundColor;

  if (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)') {
    // If background color is not set
    return 'rgb(255, 255, 255)';
  } else if (backgroundColor.includes('rgba')) {
    return `rgb(${backgroundColor
      .replace(/^rgba?\(|\s+|\)$/g, '')
      .split(',')
      .slice(0, 3)
      .join()})`;
  }

  return backgroundColor;
}
